/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { useTheme } from '../../theme';
const InlineCode = React.forwardRef((props, ref) => {
    const theme = useTheme();
    return (jsx("code", Object.assign({}, props, { ref: ref, css: {
            boxSizing: 'border-box',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: theme.colors.inlineCode.border,
            backgroundColor: theme.colors.inlineCode.background,
        } })));
});
InlineCode.displayName = 'InlineCode';
export default React.memo(InlineCode);
//# sourceMappingURL=InlineCode.js.map